module.exports = __webpack_public_path__ + "img/box-packaging@2x.e9f8a136.png";